var render, staticRenderFns
import script from "./SportHome.vue?vue&type=script&lang=tsx"
export * from "./SportHome.vue?vue&type=script&lang=tsx"
import style0 from "./SportHome.vue?vue&type=style&index=0&id=3a0c4223&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0c4223",
  null
  
)

export default component.exports